<template>
 <div>
    <v-card>
      <v-toolbar light prominent flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout v-show="cxt.isFilterMode() && cxt.isSelectMode()" style="overflow:hidden" justify-end>
          </v-layout>
          <v-layout v-show="!(cxt.isFilterMode() && cxt.isSelectMode())" style="overflow:hidden" justify-end>
              <v-chip
                v-for="tagId in tagIds"
                :key = tagId
                small
                disabled
                text-color="secondary"
                @click="selectTag()"
                >
                <span class="text-xs-center" v-html="formatTagName(tagId)">
                </span>
              </v-chip>
              <v-chip
                small
                disabled
                text-color="secondary"
                @click="selectTag()"
                v-show="tagIds.length === 0"
                >
                <span class="text-xs-center">
                Метки
                </span>
              </v-chip>
          </v-layout>
          <v-flex sm4 xs4 v-if="cxt.isFilterMode()">
            <v-text-field
              autofocus
              label="Фильтр"
              v-show="cxt.isFilterMode()"
              :value="cxt.filterString"
              v-on:input="onChangeFilter"
              solo flat
            ></v-text-field>
          </v-flex>
          <span v-show="!cxt.isSelectMode()">
            <span v-show="!cxt.isFilterMode()">
              <v-btn  icon @click="addItem()">
                <v-icon>add</v-icon>
              </v-btn>
            </span>
          </span>
        <v-ops-btn :cxt="cxt" flat></v-ops-btn>
      </v-toolbar>
    <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="getItemSet.isProcessing()" :indeterminate="true"></v-progress-linear>
    <v-card-scroll ref="cardScroll" v-on:nextPage="nextPage">
      <v-list
      three-line dense>
        <template v-for="item in this.filteredItems">
          <v-list-tile v-bind:key="getItemKey(item)" @click.stop="cxt.select(getItemKey(item))"
          :value="cxt.activated(getItemKey(item))"
          active-class="v-dealger-favorite-active v-list__tile--highlighted "
          >
            <v-list-tile-content>
              <v-list-tile-title v-html="renderReference(item.ref)"></v-list-tile-title>
              <v-list-tile-sub-title>
                  {{renderHeads(item.ref)}}
                <br/>
                ИНН: <span v-html="renderInnOrInnflHtml(item.ref.inn)"></span>
                 <span style="white-space: normal;"> {{formats.blank(item.ref.address)}}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-layout justify-end>
                <v-tooltip v-show="item.accountNameShort" bottom open-delay="500">
                  <span slot="activator">
                   <v-icon>face</v-icon>
                  </span>
                  <span>{{item.accountNameShort}}</span>
                </v-tooltip>
                <v-icon v-show="item.monitoring">alarm</v-icon>
                <v-icon v-show="!item.monitoring"></v-icon>
                <v-icon v-show="item.ref.clientId">person</v-icon>
                <v-icon v-show="!item.ref.clientId"></v-icon>
                <v-icon v-show="cxt.check(getItemKey(item))">check_box</v-icon>
                <v-icon v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
              </v-layout>
              <v-layout justify-end>
                <component :is="renderCompanyFlags(item)"/>
              </v-layout>
              <v-tooltip bottom open-delay="500" max-width="20em">
                <v-list-tile-action-text slot="activator"><b>{{formats.blank(item.ref.createDate, formats.formatDate)}}</b></v-list-tile-action-text>
                Регистрация
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-scroll>
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import apimix from '../common/apimix'
  import dialogs from '../common/dialogs'
  import vOpsBtn from '../common/OpsBtn'
  import vCardScroll from '../common/CardScroll'
  import client from '../client/index.js'
  import vTagSelector from './TagSelector.vue'
  import server from '../../api/server'

  class AllScopeAction extends classes.Action {
    constructor (context) {
      super(context, 'Все',
        null,
        () => {
          this.context.cxt.showAll()
          this.context.setTags([])
        })
    }
  }

  class ShowOtherOwnersAction extends classes.Action {
    constructor (context) {
      super(context,
        'Показывать чужиx контрагентов',
        () => this.context.isShowOtherAllow() && !this.context.getItemSet.getFilter().isShowOther,
        () => this.context.switchOther(true)
        )
    }
  }

  class NotShowOtherOwnersAction extends classes.Action {
    constructor (context) {
      super(context,
        'Не показывать чужиx контрагентов',
        () => this.context.isShowOtherAllow() && this.context.getItemSet.getFilter().isShowOther,
        () => this.context.switchOther(false)
        )
    }
  }

  class CopyInnAction extends classes.Action {
    constructor (context) {
      super(context,
        'Копировать в буфер обмена',
        null,
        () => {
          this.context.copyFavorites(this.context.cxt.selectedIds)
        }
        )
    }
  }

  class AddMyContragentAction extends classes.Action {
    constructor (context) {
      super(context,
        'Добавить в Мои контрагенты',
        null,
        () => this.context.addItem()
        )
    }
  }

  class RemoveMyContragentAction extends classes.Action {
    constructor (context) {
      super(context,
        'Исключить из Моих контрагентов',
        null,
        () => {
          this.context.deleteFavorites(this.context.cxt.selectedIds)
        }
        )
    }
  }

  class ChangeTagsAction extends classes.Action {
    constructor (context) {
      super(context,
        'Метки',
        null,
        () => this.context.selectTag()
        )
    }
  }

  class UpdateTagsForItemsAction extends classes.Action {
    constructor (context) {
      super(context,
        'Пометить',
        null,
        () => {
          this.context.updateTag(this.context.cxt.selectedIds)
        })
    }
  }

  class AddItemsToMonitoringAction extends classes.Action {
    constructor (context) {
      super(context,
        'Добавить на Мониторинг',
        null,
        () => {
          this.context.addMonitoring(this.context.cxt.selectedIds)
        })
    }
  }

  class SelectAllAction extends classes.Action {
    constructor (context) {
      super(context,
        'Выбрать Всех',
        null,
        () => {
          var fxt = this.context.getItemSet.getFilter()
          server.apiGetParams(
            '/api/me/favorite/companies',
            {
              innOnly: true,
              request: {
                search: fxt.search,
                tagIds: fxt.tagIds,
                isShowOther: fxt.isShowOther,
                isMonitoring: false
              }
            },
            (data) => {
              console.log('SelectAllAction', data)
              context.cxt.selectedIds = data.map(t => t.join('_'))
            },
            (e) => {
              context.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  '})
            }
          )
        }
      )
    }
  }

  export default {
    name: 'favorite-company-set',
    components: {vOpsBtn, vCardScroll},
    mixins: [apimix],
    data: () => ({
      tags: [],
      cxt: null,
      isShowOther: false
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.actions.push(new classes.FilterAction(cxt))
      cxt.actions.push(new classes.FilterEndAction(cxt))
      // cxt.actions.push(new classes.ActiveScopeAction(cxt))
      cxt.actions.push(new AllScopeAction(this))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.SelectAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new AddMyContragentAction(this))
      cxt.actions.push(new ShowOtherOwnersAction(this))
      cxt.actions.push(new NotShowOtherOwnersAction(this))
      cxt.actions.push(new ChangeTagsAction(this))

      cxt.selectActions.push(new classes.FilterAction(cxt))
      cxt.selectActions.push(new classes.FilterEndAction(cxt))

      cxt.selectActions.push(new UpdateTagsForItemsAction(this))
      cxt.selectActions.push(new CopyInnAction(this))
      cxt.selectActions.push(new AddItemsToMonitoringAction(this))
      cxt.selectActions.push(new RemoveMyContragentAction(this))

      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new SelectAllAction(this))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectEndAction(cxt))

      cxt.title = 'Мои контрагенты'
      cxt.titleIcon = 'contacts'
      cxt.selectTitle = 'Выбор контрагента'
      cxt.filterMode = true

      this.cxt = cxt
    },
    mounted () {
      this.cxt.filterString = this.getItemSet.getFilter().search
      this.setActivated()
      this.fetchData()
    },
    props: {
      itemId: {
        type: String,
        default: null
      },
      tagIds: {
        type: Array,
        default: null
      }
    },
    watch: {
      tagIds: function (newVal, oldVal) {
        if (Array.isArray(newVal)) {
          this.$store.commit('setFavoritesFilterContext', Object.assign({}, this.getItemSet.getFilter(), {tagIds: this.tagIds, isShowOther: false}))
          this.$store.dispatch('fetchFavoriteCompanies')
        }
      },
      // getTags: function (newVal, oldVal) {
      //   if (Array.isArray(newVal)) {
      //     this.tags = this.getTagsByIds(this.tagIds)
      //   }
      // },
      itemId: function (newVal, oldVal) { // watch it
        this.fetchData()
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        profile: 'getProfile',
        getIsMobile: 'getIsMobile',
        getItemSet: 'getFavoriteSet',
        getProfileHaveClient: 'getProfileHaveClient',
        getRefToUrl: 'getRefToUrl',
        getTags: 'getTags',
        getIsAllow: 'getIsAllow',
        renderReference: 'renderReference',
        renderHeads: 'renderHeads',
        renderFlags: 'renderFlags',
        renderInnOrInnflHtml: 'renderInnOrInnflHtml'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : ''
        } else {
          return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : ''
        }
      },
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.ref.ref,
              item.ref.caption,
              item.ref.name,
              this.renderHeads(item.ref),
              item.ref.inn,
              item.ref.kpp,
              // this.formatDate(item.company.createDate),
              // this.formatDate(item.company.releaseDate),
              item.ref.address,
              item.notes,
              item.privateNotes,
              item.accountNameShort ? item.accountNameShort : this.profile.nameShort)
        }
        if ((!this.cxt.isFilterMode()) || (this.cxt.filterString === null)) {
          return this.orderedItems
        }
        let terms = formats.parseSearchTerms(this.cxt.filterString)
        if (terms.length < 1) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          let searchStr = getSearchString(item).toLowerCase()
          return terms.every(t => (searchStr.includes(t)))
        })
      },
      isMobile () {
        return this.$vuetify.breakpoint.xsOnly
      }
    },
    methods: {
      changeFilterContext (ops, force) {
        this.$store.commit('setFavoritesFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchFavoriteCompanies', force)
          self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
          }
        }
      },
      fetchData () {
        if (this.getProfileHaveClient) {
          this.changeFilterContext({tagIds: this.tagIds, search: this.cxt.filterString, isShowOther: false})
          this.$store.dispatch('fetchTags')
          this.$store.dispatch('fetchRights', {LOCAL_ADMIN_CHECK: null})
        }
      },
      nextPage () {
        this.$store.commit('nextFavoriteCompanies')
        this.$store.dispatch('fetchFavoriteCompanies')
      },
      isShowOtherAllow () {
        return this.getIsAllow({LOCAL_ADMIN_CHECK: null})
      },
      openItem (id) {
        this.dialogOpen(id)
      },
      switchOther (on) {
        this.$store.commit('setFavoritesFilterContext', Object.assign({}, this.getItemSet.getFilter(), {isShowOther: on}))
        this.$store.dispatch('fetchFavoriteCompanies')
      },
      getItemRef (item) {
        return this.getRefToUrl(item.ref.ref)
      },
      getItemKey (item) {
        return item.ref.ref + '_' + item.ref.inn + '_' + item.accountId
      },
      getRefCodefromKey (key) {
        return key.split('_')[0]
      },
      getInnfromKey (key) {
        return key.split('_')[1]
      },
      addItem () {
        this.selectClient()
      },
      addFavorites: function (values) {
        if (Array.isArray(values)) {
          var refCodes = values
          this.$store.dispatch('addFavoriteCompanies', {refCodes: refCodes, tagIds: this.tagIds})
        }
      },
      addMonitoring: function (selectedIds) {
        if (Array.isArray(selectedIds)) {
          var values = selectedIds.map(selectedId => this.getRefCodefromKey(selectedId))
          this.$store.dispatch('updateMonitoringCompanies', {refCodes: values, monitoring: true})
          this.cxt && this.cxt.toViewMode()
        }
      },
      copyFavorites: function (selectedIds) {
        if (Array.isArray(selectedIds)) {
          var values = selectedIds.map(selectedId => this.getInnfromKey(selectedId))
          var text = values.join(', ')
          this.$store.dispatch('copyToClipboard', {text: text})
          this.cxt && this.cxt.toViewMode()
        }
      },
      deleteFavorites: function (selectedIds) {
        if (Array.isArray(selectedIds)) {
          var values = selectedIds.map(selectedId => this.getRefCodefromKey(selectedId))
          dialogs.confirm(this,
          'Подтвердите',
          'Убрать из "Мои контрагенты" и отключить мониторинг компаний?',
          (self) => {
            self.$store.dispatch('deleteFavoriteCompanies', {refCodes: values})
            self.cxt && self.cxt.toViewMode()
          })
        }
      },
      selectClient () {
        client.selectRef(this, this.addFavorites, () => {}, null, null, null)
      },
      formatTagName (tagId) {
        var t = this.getTags.find(t => t.id === Math.abs(tagId))
        var n = t ? t.name : ''
        return tagId < 0 ? `- ${n}` : `${n}`
      },
      setTags (tagIds) {
        this.$router.push({path: this.$router.path, query: { tag: tagIds }})
      },
      selectTag () {
        var self = this
        const setItems = function (tagIds) {
          self.$nextTick(() => {
            self.setTags(tagIds)
          })
        }
        dialogs.register('v-tag-selector', vTagSelector)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-tag-selector v-on:close="$emit('close')"
          v-on:input="setItem"
          :fullscreen="fullscreen" :selected="selected" removeMode></v-tag-selector>
          `,
          data () {
            return {
              fullscreen: fullscreen,
              setItem: setItems,
              selected: self.tagIds
            }
          }
        }
        dialogs.modal(comp)
      },
      updateTag (selectedIds) {
        var self = this
        const setItems = function (tagIds) {
          if (Array.isArray(selectedIds)) {
            var refCodes = selectedIds.map(v => self.getRefCodefromKey(v))
            self.$store.dispatch('addFavoriteCompanies', {refCodes: refCodes, tagIds: tagIds})
            self.cxt && self.cxt.toViewMode()
          }
        }
        dialogs.register('v-tag-selector', vTagSelector)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-tag-selector v-on:close="$emit('close')"
          v-on:input="setItem"
          :fullscreen="fullscreen" :selected="selected" removeMode></v-tag-selector>
          `,
          data () {
            return {
              fullscreen: fullscreen,
              setItem: setItems,
              selected: self.tagIds
            }
          }
        }
        dialogs.modal(comp)
      },
      renderCompanyFlags (item) {
        return this.renderFlags(item.ref.flags)
      },
      scrollToActive () {
        this.$nextTick(() => {
          this.$refs.cardScroll.scrollToListActive()
        })
      },
      setActivated () {
        if (this.$router && this.$router.options && this.$router.options.from) {
          let from = this.$router.options.from
          if (from.params && from.params.clientInn) {
            let itemId = from.params.clientInn
            let item = this.items.find(i => '' + i.ref.ogrn === itemId)
            if (item) {
              this.cxt.activate(this.getItemKey(item))
            } else {
              this.$store.commit('setInfoStatus',
                'Позиционировать не удалось, возможно выборка была изменена. '
              )
            }
          }
          if (from.params && from.params.fagencyId) {
            let itemId = from.params.fagencyId
            let item = this.items.find(i => '' + i.ref.nza === itemId)
            if (item) {
              this.cxt.activate(this.getItemKey(item))
            } else {
              this.$store.commit('setInfoStatus',
                'Позиционировать не удалось, возможно выборка была изменена. '
              )
            }
          }
          if (from.params && from.params.lonerId) {
            let itemId = from.params.lonerId
            let item = this.items.find(i => '' + i.ref.ogrnip === itemId)
            if (item) {
              this.cxt.activate(this.getItemKey(item))
            } else {
              this.$store.commit('setInfoStatus',
                'Позиционировать не удалось, возможно выборка была изменена. '
              )
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FavoriteCompanySet.vue?297377e6